import { Injectable } from '@angular/core';
import { Response, ResponseContentType, RequestOptions, URLSearchParams } from '@angular/http';

import { AuthHttp, QueryEncoderHelper } from 'app/infrastructure/common';
import { AppSettings } from 'app/infrastructure/settings';

@Injectable()
export class AnnouncementStatusService {
    constructor(private http: AuthHttp) { }

    getAnnouncementStatusByAll(isIncludeAll?: boolean) {
        let params: URLSearchParams = new URLSearchParams();
        params.set('isIncludeAll', String(isIncludeAll));

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + 'AnnouncementStatus/GetAnnouncementStatusByAll', options)
            .map((response: Response) => response.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/infrastructure/services/transaction/op/announcement/announcement-status.service.ts